var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],staticClass:"preloader__backdrop"},[_c('f7-preloader',{attrs:{"size":"26"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }